import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../helpers";
import { OmitStrict } from "../utils";

export const WorkspaceUntypedData = z.object({
  id: z.string(),
  workspaceId: z.string(),
  value: z.unknown(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type WorkspaceUntypedData = z.infer<typeof WorkspaceUntypedData>;

export type WorkspaceUntypedDataCreate = DbCreateInputOmit<WorkspaceUntypedData>;
export type WorkspaceUntypedDataUpdate = OmitStrict<DbUpdate<WorkspaceUntypedData>, "id" | "workspaceId">;
